import { forwardRef } from 'react'
import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'

export interface PopoverTriggerProps extends Popover.Trigger.Props {
  className?: string
}

const PopoverTrigger = forwardRef<HTMLButtonElement, PopoverTriggerProps>(function PopoverTrigger(
  { className, children, render, ...props },
  ref,
) {
  return (
    <Popover.Trigger
      ref={ref}
      // A rendered element brings its own styling; the reset would strip its padding and fill.
      className={
        render ? className : twMerge('flex items-center justify-center bg-transparent p-0 outline-none', className)
      }
      render={render}
      {...props}
    >
      {children}
    </Popover.Trigger>
  )
})

export { PopoverTrigger }
